import { render, staticRenderFns } from "./EmployeeDetailFormCard.vue?vue&type=template&id=3c58a62a&"
import script from "./EmployeeDetailFormCard.vue?vue&type=script&lang=ts&"
export * from "./EmployeeDetailFormCard.vue?vue&type=script&lang=ts&"
import style0 from "./EmployeeDetailFormCard.vue?vue&type=style&index=0&id=3c58a62a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports